module.exports = __webpack_public_path__ + "../static/img/base_reap.9f274af8.png";